import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';
import { Tooltip } from 'bootstrap';
import { getConvertedDateTime } from 'src/app/utils/timeManager';
import { HttpClient } from '@angular/common/http';
import { log } from 'src/app/utils/logging';
import { PaginationInstance } from 'ngx-pagination';
import { AgentListInfo } from 'src/app/services/agent.list.info';
import { Agent, ISupervisorInit } from 'src/app/interfaces/agent.interface';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-mainsuper-admin',
  queries: {
    "scrollContainerRef1": new ViewChild("scrollContainerRef1")
  },
  templateUrl: './mainsuper-admin.component.html',
  styleUrls: ['./mainsuper-admin.component.sass']
})
export class MainsuperAdminComponent implements OnInit {

  searchText: string;
  appConfig = AppConfig;
  agentViolationList: any = [];
  violationList: string;
  searchviolationList: string;
  sortOrder: string = 'ASC';
  hideLoading: boolean = false;
  isSuperAdminShown: boolean = false;

  scrollContainerRef1!: ElementRef; // Using "definite assignment" assertion (query).

  public config: PaginationInstance = {
    id: 'paginationid1',
    itemsPerPage: 10,
    currentPage: 1
  };

  totalPages = 1;

  paginationViolationList: any;

  superadminLabel: string = "";
  sortAgentsLabel: string = "";
  searchLabel: string = "";
  noEscalatedEventsLabel: string = "";
  itemsPerPageLabel: string = "";
  previousLabel: string = "";
  nextLabel: string = "";

  constructor(private trsService: TrsEventsService, private http: HttpClient, private agentListInfoService: AgentListInfo,
    private translationService: TranslocoService) {
    this.updateComponentLabels();
  }

  ngOnInit(): void {
    this.trsService.evtDataObservable.subscribe(response => {
      switch (response.eventName) {
        case "UPDATE_APP_LABELS": this.updateComponentLabels(); break;
        case "SUPERVISORINIT": this.getSupervisorInit(response.data); break
        case "GETAGENTSESSIONLIST": this.getAgentList(response.data); break;
        case "VIOLATIONWORKFLOW":
        case "SUPERADMIN_MODE": this.getEscalatedViolationList(response.data); break;
        case "SUPERADMIN_APPROVAL": this.removeViolationFromEscalationList(response.data); break;
      }
    });
  }

  getAgentList(response: any) {
    this.agentViolationList.forEach((violation: any, i: number) => {
      const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(violation.AgentLanId);

      if (agentInfo != null) {
        violation.AgentFirstName = agentInfo.AgentFirstName;
        violation.AgentLastName = agentInfo.AgentLastName;
        violation.FullName = agentInfo.FullName;
        violation.AgentProfilePic = agentInfo.AgentProfilePic;
      }
      else {
        this.agentViolationList = this.agentViolationList.filter((agent: { AgentLanId: any; }) => agent.AgentLanId != violation.AgentLanId);
      }
    });
    this.hideLoading = true;
    this.sortAgentsByDateArray();
  }

  loadTooltip() {
    try {
      let interval = setInterval(() => {
        Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
          .forEach(tooltipNode => new Tooltip(tooltipNode, {
            delay: { show: 100, hide: 800 },
            trigger: 'hover',
          }));
      }, 1000);

      setTimeout(function () {
        clearInterval(interval);
      }, 2000) // stop it after 10seconds
    } catch (err) { }
  }

  sortAgentsByDateArray(toggle = true) {
    if (toggle) {
      this.sortOrder == "ASC" ? this.sortOrder = "DESC" : this.sortOrder = "ASC";
    }

    if (this.sortOrder == "ASC") {
      this.agentViolationList.sort((a: any, b: any) => {
        var dateA = new Date(a.FormattedSentDateTime);
        var dateB = new Date(b.FormattedSentDateTime);
        return (dateA < dateB) ? -1 : (dateA > dateB) ? 1 : 0;
      });
    }
    else {
      this.agentViolationList.sort((a: any, b: any) => {
        var dateA = new Date(a.FormattedSentDateTime);
        var dateB = new Date(b.FormattedSentDateTime);
        return (dateA < dateB) ? 1 : (dateA > dateB) ? -1 : 0;
      });
    }
    this.pageChanged(1);
  }

  getEscalatedViolationList(data: any) {
    if (this.isSuperAdminShown === true) {
      const baseURL: string | null = AppConfig.GetServerBaseURL();
      if (baseURL != null && baseURL != '') {
        const selectedURL: string = `${baseURL}api/getviolations?teamid=${data.teamId}`;
        this.agentViolationList = [];
        this.http.get(selectedURL, {}).subscribe((response: any) => {
          log.debug(`getEscalatedViolationList response`, response);
          if (response) {
            response.forEach((violation: any) => {
              const agentInfo: Agent | undefined = this.agentListInfoService.GetAgentInfoFromAvayaLoginId(violation.AgentId);

              if (agentInfo != null) {
                violation.AgentFirstName = agentInfo.AgentFirstName;
                violation.AgentProfilePic = agentInfo.AgentProfilePic;
                violation.AgentLastName = agentInfo.AgentLastName;
                violation.AgentLanId = agentInfo.LanID;
                violation.IsSelected = false;
                violation.FormattedSentDateTime = getConvertedDateTime(violation.SentDateTime);
                this.agentViolationList.push(violation);
              }
              else log.error(`Unable to get agent info for AvayaloginId ${violation.AgentId}, hence skipping adding violation with event id ${violation.EventId} to superadmin list`);
            });

            if (this.agentViolationList != null) {
              if (this.agentViolationList[0] != null) {
                this.agentViolationList[0].isSelected = true;
              }
              this.pageChanged(1);

              this.sendEvent("SELECTED_VIOLATION", this.agentViolationList[0]);
            }

          }
        },
          (error: any) => {
            log.error(`getEscalatedViolationList error`, error);
          });
      }
    }
  }

  removeViolationFromEscalationList = (data: any) => {
    if (data != null && data.eventId != null && data.eventId != "") {
      this.agentViolationList = this.agentViolationList.filter((item: any) => item.EventId !== data.eventId);

      this.agentViolationList.forEach((violation: any) => {
        violation.isSelected = false;
      });

      this.sendEvent("SELECTED_VIOLATION", null);

      if (this.agentViolationList.length > 0) {
        let totalPages: number = Math.ceil(this.agentViolationList.length / this.config.itemsPerPage);

        if (this.config.currentPage > totalPages) {
          this.pageChanged(Math.trunc(totalPages));
        }
        else if (this.config.currentPage <= totalPages) {
          this.pageChanged(this.config.currentPage);
        }

        this.agentViolationList.forEach((violation: any) => {
          violation.isSelected = false;
        });
      }
      else {
        this.pageChanged(1);
      }
    }
  }

  pageChanged(page: any): void {
    this.config.currentPage = page;
    let begin = (this.config.currentPage - 1) * this.config.itemsPerPage;
    let end = begin + this.config.itemsPerPage;
    this.paginationViolationList = this.agentViolationList.slice(begin, end);
    this.totalPages = Math.ceil(this.agentViolationList.length / this.config.itemsPerPage)

    this.scrollContainerRef1.nativeElement.scrollTo(0, 0);
  }

  sendEvent(eventName: any, responseData: any) {
    let data = {
      "eventName": eventName,
      "data": responseData
    };
    this.trsService.evtdata.next(data);
  }


  pageSizeChange(pSize: any): void {
    this.config.itemsPerPage = parseInt(pSize)
    this.pageChanged(1)
  }

  getSupervisorInit(response: any) {
    this.agentViolationList = [];

    if (response != null) {
      const supervisorInfo: ISupervisorInit = response;
      if (supervisorInfo.IsTeamLevelSupervisor === true)
        this.isSuperAdminShown = false;
      else this.isSuperAdminShown = true;
    }
  }

  updateComponentLabels = (): void => {
    this.superadminLabel = this.translationService.translate("SuperAdmin Dashboard");
    this.sortAgentsLabel = this.translationService.translate("Sort Agents");
    this.searchLabel = this.translationService.translate("Search");
    this.noEscalatedEventsLabel = this.translationService.translate("No Escalated Events");
    this.itemsPerPageLabel = this.translationService.translate("Items per page");
    this.previousLabel = this.translationService.translate("Prev");
    this.nextLabel = this.translationService.translate("Next");
  }
}